import { useState } from "react";
import "./Auth.css";

function CambiarPasswordPrimera() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const cambiar = async () => {
    if (password.length < 6) {
      alert("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    const email = localStorage.getItem("emailTemp");
    if (!email) {
      alert("Sesión inválida. Inicia sesión nuevamente.");
      window.location.href = "/";
      return;
    }

    setLoading(true);

    const res = await fetch(
      "https://sindicato.sintrasecsalud.com/api/index.php?modulo=auth&accion=cambiarPasswordPrimeraVez",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      },
    );

    const data = await res.json();
    setLoading(false);

    if (data.success) {
      alert("Contraseña actualizada correctamente");
      localStorage.removeItem("emailTemp");
      window.location.href = "/";
    } else {
      alert(data.message || "Error...");
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h4>Cambiar contraseña</h4>

        <input
          type="password"
          className="form-control auth-input mb-3"
          placeholder="Nueva contraseña"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={cambiar} className="auth-btn" disabled={loading}>
          {loading ? "Guardando..." : "Cambiar contraseña"}
        </button>
      </div>
    </div>
  );
}

export default CambiarPasswordPrimera;
